module.exports = __webpack_public_path__ + "img/art_3_5.9e2c3cac.png";